import { LINKS } from "./links";

export const FACILITATIONS = {
  INDUSTRY_4: {
    title: "Industria 4.0",
    content: "Innovazione e digitalizzazione",
    image: "/images/agevolazioni/Industria_4_0.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.INDUSTRY_4,
    },
  },
  INDUSTRY_5: {
    title: "Industria 5.0",
    content: "Tecnologia per la sostenibilità ambientale",
    image: "/images/agevolazioni/Industria_5_0.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.INDUSTRY_5,
    },
  },
  NUOVA_SABATINI: {
    title: "Nuova Sabatini",
    content: "Finanziamenti agevolati per rinnovare beni strumentali",
    image:
      "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-NuovaSabatini-thumb.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.NUOVA_SABATINI,
    },
  },
  ZES: {
    title: "ZES",
    content: "Agevolazioni per imprese del Sud e delle zone speciali",
    image: "/images/agevolazioni/zes.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.ZES,
    },
  },
  SIMEST: {
    title: "Simest",
    content: "Agevolazioni legate all’internazionalizzazione delle PMI",
    image:
      "/images/finance/PROSSIMITI-FINANZAAGEVOLATA-Servizio-Internazionalizzazione-thumb.jpg",
    button: {
      title: "LE NOSTRE SOLUZIONI",
      link: LINKS.SIMEST,
    },
  },
};
